import { render, staticRenderFns } from "./ItalyXML.vue?vue&type=template&id=6ec3fcc0&scoped=true&"
import script from "./ItalyXML.vue?vue&type=script&lang=js&"
export * from "./ItalyXML.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec3fcc0",
  null
  
)

export default component.exports